import { useEffect, useRef, useState } from "react";
import { SwiperSlide, Swiper } from "swiper/react";
import { RunnerCompetitionDto } from "../../../../../../../api/runner-competition";
import {
  FestivalCompetitionsBannerProgress,
  FestivalCompetitionsBannerSwiper,
  FestivalCompetitionsBannerSwiperText,
  FestivalCompetitionsBannerWrapper,
} from "./style";
import { useRabbitFestivalContext } from "../../../../hooks/festival-context";
import { Autoplay } from "swiper/modules";

interface RabbitFestivalCompetitionsBannerProps {
  list: RunnerCompetitionDto[];
}

export const RabbitFestivalCompetitionsBanner = ({
  list,
}: RabbitFestivalCompetitionsBannerProps) => {
  const [currenIndex, setCurrentIndex] = useState(0);
  const { setShowHeader, handleCompetitionPage } = useRabbitFestivalContext();
  const bannerRef = useRef<HTMLDivElement>(null);

  // header 투명 여부
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (target.isIntersecting) {
          setShowHeader(true);
        } else {
          setShowHeader(false);
        }
      },
      {
        threshold: 0.5,
      }
    );

    if (bannerRef.current) {
      observer.observe(bannerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [bannerRef.current]);

  return (
    <FestivalCompetitionsBannerWrapper ref={bannerRef}>
      <Swiper
        className="banner-swiper"
        onRealIndexChange={(swiper: any) =>
          setCurrentIndex(swiper.realIndex || 0)
        }
        slidesPerView={1}
        autoplay={{ delay: 4000 }}
        modules={[Autoplay]}
      >
        {list.map((item, i) => (
          <SwiperSlide key={i} onClick={() => handleCompetitionPage(item.id)}>
            <FestivalCompetitionsBannerSwiper>
              <img src={item.bannerImage} alt="banner" />
              <div className="back" />
              <FestivalCompetitionsBannerSwiperText>
                <div className="title">{item.title}</div>
                <div className="subTitle">{item.subTitle}</div>
              </FestivalCompetitionsBannerSwiperText>
            </FestivalCompetitionsBannerSwiper>
          </SwiperSlide>
        ))}
      </Swiper>
      <FestivalCompetitionsBannerProgress
        currenIndex={currenIndex}
        width={100 / list.length}
      >
        {list?.map((_, i) => (
          <div key={i} className="dot" />
        ))}
        <div className="bar" />
        <div className="background" />
      </FestivalCompetitionsBannerProgress>
    </FestivalCompetitionsBannerWrapper>
  );
};

export default RabbitFestivalCompetitionsBanner;
